export { default } from './SWNavigationalTabs';
